import { z } from 'zod';
import { kullanici } from './kullanici.js';
// Admin paneli girisi: eposta + parola
export const adminGirisIstegi = z.object({
    eposta: z.string().email().max(254),
    parola: z.string().min(8).max(128),
});
// Mobil/musteri girisi: telefon + (parola veya SMS kod) — sonraki adimda kullanilir
export const musteriGirisIstegi = z.object({
    telefon: z.string().min(10).max(20),
    parola: z.string().min(8).max(128).optional(),
    smsKod: z
        .string()
        .regex(/^\d{4,6}$/)
        .optional(),
});
export const oturumCevabi = z.object({
    erisimJeton: z.string(),
    yenilemeJeton: z.string(),
    erisimSuresiSn: z.number().int(),
    yenilemeSuresiSn: z.number().int(),
    kullanici: kullanici,
});
export const yenilemeIstegi = z.object({
    yenilemeJeton: z.string().min(10),
});
//# sourceMappingURL=oturum.js.map